goog.provide("shadow.js.shim.module$src$svg$files_folders$bin_svg$default");
shadow.js.shim.module$src$svg$files_folders$bin_svg$default = shadow.js.shim.module$src$svg$files_folders$bin_svg.default;
